/**
 * @license
 * Copyright 2024 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */
import { ProxyClient } from "../remote/proxy.js";
const isProxyKitConfig = (kitOrConfig) => {
    return "proxy" in kitOrConfig;
};
export const configureKits = (kits, factory) => {
    return kits.map((kit) => {
        if (isProxyKitConfig(kit)) {
            const proxyClient = new ProxyClient(factory.client("proxy"));
            return proxyClient.createProxyKit(kit.proxy);
        }
        return kit;
    });
};
//# sourceMappingURL=kits.js.map